'use client';

import { useCallback } from 'react';

export const PromotionGameLauncher = ({
    url,
    onLaunch,
    children
}: {
    url: string;
    onLaunch: (url: string) => void;
    children: React.ReactNode;
}) => {
    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            onLaunch(url);
        },
        [url, onLaunch]
    );

    return (
        <div onClickCapture={handleClick} role="button" tabIndex={0} style={{ cursor: 'pointer', width: '100%' }}>
            {children}
        </div>
    );
};

PromotionGameLauncher.displayName = 'PromotionGameLauncher';
